var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.4925 2.1665H6.50833C3.975 2.1665 2.5 3.64984 2.5 6.1915V14.7998C2.5 17.3832 3.975 18.8332 6.50833 18.8332H13.4925C16.0667 18.8332 17.5 17.3832 17.5 14.7998V6.1915C17.5 3.64984 16.0667 2.1665 13.4925 2.1665Z",
    fill: "#DCE3DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7333 13.6165H13.2666C13.5991 13.6498 13.85 13.9332 13.85 14.2748C13.85 14.6073 13.5991 14.8915 13.2666 14.9248H6.7333C6.4833 14.9582 6.24163 14.8332 6.1083 14.6248C5.97497 14.4082 5.97497 14.1332 6.1083 13.9248C6.24163 13.7082 6.4833 13.5915 6.7333 13.6165ZM13.2666 9.81567C13.625 9.81567 13.9166 10.1082 13.9166 10.4665C13.9166 10.8248 13.625 11.1165 13.2666 11.1165H6.7333C6.37413 11.1165 6.0833 10.8248 6.0833 10.4665C6.0833 10.1082 6.37413 9.81567 6.7333 9.81567H13.2666ZM9.22413 6.0415C9.5833 6.0415 9.87497 6.33317 9.87497 6.69067C9.87497 7.05817 9.5833 7.34984 9.22413 7.34984H6.7333C6.37413 7.34984 6.0833 7.05817 6.0833 6.69984C6.0833 6.3415 6.37413 6.04984 6.7333 6.04984V6.0415H9.22413Z",
    fill: "#02291C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.e8653725.svg";
export { ForwardRef as ReactComponent };